import { useMediaQuery, useTheme } from '@ingeniorforeningen/figurine-core';

export const useIsColumn = () => {
  const theme = useTheme();
  const isColumn = useMediaQuery(`(max-width: ${theme.breakpoints?.sm})`);

  return { isColumn };
};
